export enum CouponTypesEnum {
  FOR_BOOK_PURCHASE = 'book_purchase',
  FOR_PLAN_PURCHASE = 'plan_purchase',
  FOR_CREDITS_PURCHASE = 'credits_purchase',
  FOR_STORY_PURCHASE = 'story_purchase'
}

export enum CouponDurationEnum {
  ONCE = 'once',
  REPEATING = 'repeating',
  FOREVER = 'forever'
}

export interface CouponModel {
  id?: number | string;
  couponCode?: string;
  couponType?: string;
  couponAppliedFor?: string;
  couponValidity?: string;
  couponDescription?: string;
  couponAmount?: string;
  couponExpiry?: string;
}